import { GameContext } from '../../../contexts/GameContext';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { isEmptyObject } from '../../../util/isEmptyObject';
import { useContext } from 'react';
import GameWrapper from '../../../components/common/wrappers/GameWrapper';
import Loading from '../../../components/common/Loading';
import MDiaryIcon from '../../../components/games/m-game/MDiaryIcon';
import MTaskText from '../../../components/games/m-game/MTaskText';
import MTaskTitle from '../../../components/games/m-game/MTaskTitle';

type Props = {
    title?: string;
    currentStep: number;
};

export default function MEnding(props: Props) {
    const { availableGame } = useContext(ProfileContext);

    const { stepContent } = useContext(GameContext);
    const { title, taskText } = stepContent;

    if (isEmptyObject(stepContent)) {
        return (
            <>
                <GameWrapper>
                    <div className="card game-card">
                        <Loading color="#6f32a8" />
                    </div>
                </GameWrapper>
            </>
        );
    }

    if (availableGame) {
        const lastStep = availableGame.lastStep;
        if (lastStep === null || (lastStep && props.currentStep < lastStep)) {
            return (
                <>
                    <GameWrapper>
                        <div className="card game-card">
                            <Loading color="#6f32a8" />
                        </div>
                    </GameWrapper>
                </>
            );
        }
    }

    return (
        <div className="card game-card">
            {title && <MTaskTitle text={title} />}
            {taskText && <MTaskText text={taskText} title={title} />}
            <MDiaryIcon />
        </div>
    );
}
